import { AddressJSON } from "_shared/addresses/address-schema";
import Guid from "_shared/guids/guid";
import EntityOfficerInvitation from "legal-entities/invitations/officer-invitations/entity-officer-invitation";

export default class InviteEntityOfficerAPIRequest {
  public operationId: string;
  public email: string;
  public firstName?: string;
  public lastName?: string;
  public entityName: string;
  public message?: string;
  public entityLocation?: AddressJSON;
  public title?: string;
  public onboardingTemplateId?: string;
  public sponsoringClientLegalEntityId?: string;
  public sponsoringClientRepresentativeUserId?: string;

  public constructor(invitation: EntityOfficerInvitation, operationId: Guid) {
    if (!invitation.registrationInfo) throw new Error("Registration info is required");
    if (!invitation.entityName) throw new Error("Entity name is required");
    if (!invitation.registrationInfo.email) throw new Error("Email address is required");
    if (!invitation.registrationInfo.name) throw new Error("Name is required");

    this.operationId = operationId.value;
    this.email = invitation.registrationInfo.email.value;
    this.firstName = invitation.registrationInfo.name.firstName;
    this.lastName = invitation.registrationInfo.name.lastName;
    this.entityName = invitation.entityName.value;
    this.message = invitation.message?.value;
    this.entityLocation = invitation.entityLocation?.toJSON();
    this.title = invitation.title?.value;
    this.onboardingTemplateId = invitation.onboardingTemplateId;
    // Both or neither. The server drops a half-written sponsor rather than sending a letter with
    // a blank where the client's name belongs, and there is no reason to make it do that work.
    const sponsoringClientLegalEntityId = invitation.sponsoringClientLegalEntityId?.value;
    const sponsoringClientRepresentativeUserId = invitation.sponsoringClientRepresentativeUserId?.value;
    if (sponsoringClientLegalEntityId && sponsoringClientRepresentativeUserId) {
      this.sponsoringClientLegalEntityId = sponsoringClientLegalEntityId;
      this.sponsoringClientRepresentativeUserId = sponsoringClientRepresentativeUserId;
    }
  }
}
